import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaUser, FaEnvelope, FaPhone, FaMapMarkerAlt, FaBirthdayCake, FaEdit, FaSave, FaTimesCircle, FaExclamationTriangle } from 'react-icons/fa';
import './MonProfil.css';
import { getAuthServerBase } from '../utils/runtime';

const AUTH_SERVER = getAuthServerBase();

function MonProfil() {
  const [user, setUser] = useState(null);
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const redirect = new URLSearchParams(location.search).get('redirect');

  useEffect(() => {
    let email = null;

    fetch(`${AUTH_SERVER}/me`, { credentials: 'include' })
      .then(res => {
        if (!res.ok) throw new Error('Non authentifié');
        return res.json();
      })
      .then(userInfo => {
        email = userInfo.email;
        return fetch(`https://1irywxa5c3.execute-api.ca-central-1.amazonaws.com/prod/users/email/${email}`);
      })
      .then(res => res.json())
      .then(data => {
        setUser(data);
        setForm(data);
        setLoading(false);
      })
      .catch(err => {
        console.error('Erreur chargement profil:', err);
        setLoading(false);
      });
  }, []);

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSave = () => {
    const userUpdate = {
      first_name: form.first_name,
      last_name: form.last_name,
      phone: form.phone
    };

    const patientUpdate = {
      birth_date: form.birth_date,
      emergency_contact: form.emergency_contact,
      address: form.address,
      postal_code: form.postal_code
    };

    fetch(`https://1irywxa5c3.execute-api.ca-central-1.amazonaws.com/prod/users/${user.user_id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(userUpdate)
    })
      .then(res => {
        if (!res.ok) throw new Error('Échec mise à jour users');
        return res.json();
      })
      .then(() =>
        fetch(`https://1irywxa5c3.execute-api.ca-central-1.amazonaws.com/prod/patients/${user.user_id}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(patientUpdate)
        })
      )
      .then(res => {
        if (!res.ok) throw new Error('Échec mise à jour patients');
        return res.json();
      })
      .then(() => {
        alert('✅ Profil mis à jour');
        setIsEditing(false);
        if (redirect === 'dashboard') {
          navigate('/patient/dashboard');
        }
      })
      .catch(err => {
        console.error('Erreur mise à jour complète:', err);
        alert("❌ Échec de la mise à jour");
      });
  };

  if (loading) return <p className="profil-loading">Chargement...</p>;
  if (!user) return <p className="profil-error">Utilisateur non trouvé.</p>;

  const profilIncomplet = !user.birth_date || !user.address || !user.postal_code;

  return (
    <div className="profil-container">
      <h2 className="profil-title">Mon profil</h2>

      {profilIncomplet && (
        <div className="profil-warning">
          <FaExclamationTriangle /> Votre profil est incomplet. Veuillez compléter les informations obligatoires.
        </div>
      )}

      <div className="profil-card">
        {isEditing ? (
          <form className="profil-form" onSubmit={e => e.preventDefault()}>
            <label>Prénom : <input name="first_name" value={form.first_name || ''} onChange={handleChange} /></label>
            <label>Nom : <input name="last_name" value={form.last_name || ''} onChange={handleChange} /></label>
            <label>Date de naissance : <input name="birth_date" type="date" value={form.birth_date || ''} onChange={handleChange} /></label>
            <label>Téléphone : <input name="phone" value={form.phone || ''} onChange={handleChange} /></label>
            <label>Adresse : <input name="address" value={form.address || ''} onChange={handleChange} /></label>
            <label>Code postal : <input name="postal_code" value={form.postal_code || ''} onChange={handleChange} /></label>
            <label>Contact d'urgence : <input name="emergency_contact" value={form.emergency_contact || ''} onChange={handleChange} /></label>
            <div className="profil-actions">
              <button className="btn-primary" onClick={handleSave}><FaSave /> Enregistrer</button>
              <button className="btn-outline" onClick={() => setIsEditing(false)}><FaTimesCircle /> Annuler</button>
            </div>
          </form>
        ) : (
          <div className="profil-details">
            <p><FaUser /> <strong>Nom :</strong> {user.first_name} {user.last_name}</p>
            <p><FaEnvelope /> <strong>Email :</strong> {user.email}</p>
            <p><FaBirthdayCake /> <strong>Date de naissance :</strong> {user.birth_date || 'Non renseignée'}</p>
            <p><FaPhone /> <strong>Téléphone :</strong> {user.phone || 'Non renseigné'}</p>
            <p><FaMapMarkerAlt /> <strong>Adresse :</strong> {user.address || 'Non renseignée'}</p>
            <p><strong>Code postal :</strong> {user.postal_code || 'Non renseigné'}</p>
            <p><strong>Contact d'urgence :</strong> {user.emergency_contact || 'Non renseigné'}</p>
            <div className="profil-actions">
              <button className="btn-primary" onClick={() => setIsEditing(true)}><FaEdit /> Modifier</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default MonProfil;
